<template>
  <p v-if="condition" class="flex items-center font-small tracking-wide text-red-500 text-xs mb-0 mt-1">
    {{ label }}
  </p>
</template>

<script>
export default {
  props: {
    condition: Boolean,
    label: String,
  },
}
</script>